module.exports = __webpack_public_path__ + "img/paypal-icon.76f72f4d.svg";